<template>
  <div>
    <CurriculumHead></CurriculumHead>
    <CurriculumDetail :id="id"></CurriculumDetail>
    <div>
      <b-container>
        <CurriculumFeatures :id="id"></CurriculumFeatures>
      </b-container>
    </div>
    <CurriculumCoding :id="id"></CurriculumCoding>
    <CurriculumUX :id="id"></CurriculumUX>
    <div>
      <b-container>
        <CurriculumRelevant :id="id"></CurriculumRelevant>
      </b-container>
    </div>
    <CurriculumFooter></CurriculumFooter>
  </div>
</template>

<script>
import CurriculumFeatures from "@/components/curriculum-components/CurriculumFeatures.vue";
import CurriculumFooter from "@/components/curriculum-components/CurriculumFooter.vue";
import CurriculumRelevant from "@/components/curriculum-components/CurriculumRelevant.vue";
import CurriculumCoding from "@/components/curriculum-components/CurriculumCoding.vue";
import CurriculumUX from "@/components/curriculum-components/CurriculumUX.vue";
import CurriculumHead from "@/components/curriculum-components/CurriculumHead.vue";
import CurriculumDetail from "@/components/curriculum-components/CurriculumDetail.vue";

export default {
  components: {
    CurriculumFeatures,
    CurriculumFooter,
    CurriculumRelevant,
    CurriculumCoding,
    CurriculumUX,
    CurriculumHead,
    CurriculumDetail
  },
  props: {
    id: {
      type: Number
    }
  }
};
</script>

<style scoped>
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}
ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
</style>
